import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@radix-ui/react-dropdown-menu";
import React, { createContext, useState, useEffect } from "react";
import CategoriesDropdown from "../../components/UI/CategoriesDropdown";
import CategoryContents from "../../components/UI/CategoryContents";
import {
  allMainCategoryApi,
  subChildCatergoryApi,
} from "../../Apis/CategoryApi";

// Create a context
export const DropdownContext = createContext();

export const Categories = () => {
  const [selectedCategory, setSelectedCategory] = useState(
    "Consumer Electronics"
  );
  const [mainCategory, setMainCategory] = useState([]);
  const [subCategory, setSubCategory] = useState([]);
  const [idx, setIdx] = useState(0);
  const [title, setTitle] = useState("Consumer Electronics");

  // GET Main Category
  const getMainCategories = async () => {
    if (mainCategory.length === 0) {
      try {
        const response = await allMainCategoryApi();
        setMainCategory(response?.category);
      } catch (error) {
        console.error("Error fetching main category", error);
      }
    }
  };

  useEffect(() => {
    getMainCategories();
  }, []);

  // Fetch sub and child categories
  const getSubChildCategories = async (selectedMainCategory) => {
    try {
      const response = await subChildCatergoryApi(selectedMainCategory);
      if (response && response.category) {
        setSubCategory(response?.category);
      } else if (response && response.message) {
        console.error("Error fetching sub/child category:", response.message);
      }
    } catch (error) {
      console.error("Error fetching sub/child category", error);
    }
  };

  useEffect(() => {
    getSubChildCategories(selectedCategory);
  }, [selectedCategory]);

  // Handler for category selection
  const handleCategorySelect = (category) => {
    setSelectedCategory(category);
    getSubChildCategories(category);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="flex gap-x-[4px] select-none">
          <div className="flex items-center justify-center gap-x-[4px] mr-[6px] select-none">
            <p className="hover:text-[#FF6300] cursor-pointer w-[67px] h-[18px] text-[13px] flex items-center justify-center">
              Categories
            </p>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M4 6L8 10L12 6"
                stroke="black"
                strokeOpacity="0.6"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className={`z-50 w-[1245px] rounded-[10px] absolute -left-[78px] h-[609px] mt-[10px] bg-white shadow-[0_0px_0px_1px_rgba(0,0,0,0.07)] flex flex-col
      `}
      >
        <hr className="w-full bg-black" />

        <div className="max-w-[1240px] mx-auto">
          <h2 className="w-[1240px] text-start text-[16px] px-[23px] font-semibold pt-[26px] pb-[21px] text-[#FF6300]">
            Categories
          </h2>
        </div>
        <DropdownContext.Provider
          value={{
            selectedCategory,
            setSelectedCategory,
            getSubChildCategories,
          }}
        >
          <div className="max-w-[1240px] mx-auto">
            <div className="w-full h-[326px] flex gap-x-[21px]">
              <CategoriesDropdown
                mainCategory={mainCategory}
                setIdx={setIdx}
                setTitle={setTitle}
                onCategorySelect={handleCategorySelect}
              />
              <CategoryContents
                idx={idx}
                title={title}
                subCategory={subCategory}
              />
            </div>
          </div>
        </DropdownContext.Provider>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
